import { Box } from "@mui/material";
import { Account } from "@rentablo/api/apiv1";
import { CardHeading } from "@rentablo/components";
import { AccountsHeader, CurrencyToggle } from "@components";
import AccountPreviewIcon from "@components/Accounts/AccountPreviewCard/AccountPreviewIcon";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";
import { SingleAccountPageActions } from "./SingleAccountPageActions";

interface Props {
  accountId: number;
  account?: Account;
}

export const SingleAccountPageHeading = ({ accountId, account }: Props) => {
  const { globalCurrency } = useCurrencyDisplay();
  const hasForeignCurrency = Boolean(
    account?.currency &&
      account.currency.toUpperCase() !== globalCurrency.toUpperCase()
  );

  return (
    <CardHeading
      actionsInline
      title={
        <AccountsHeader
          title={account?.name ?? ""}
          subtitle={account?.bankName ?? ""}
          nativeCurrency={
            account?.currency && account.currency !== globalCurrency
              ? account.currency
              : undefined
          }
          icon={
            account ? (
              <AccountPreviewIcon
                isReference={Boolean(account.depotIds?.length ?? 0)}
                iconUrl={account.iconUrl}
                type={account.type}
                hideRefIcon
                size={48}
              />
            ) : (
              <></>
            )
          }
        />
      }
      actions={
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          gap={2}
        >
          <SingleAccountPageActions accountId={accountId} />
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <CurrencyToggle
              storageKey="currency-toggle-account"
              originalCurrency={account?.currency}
            />
          </Box>
        </Box>
      }
      // Only with a currency to switch: an empty slot would still add the
      // heading's gap above the chart.
      below={
        hasForeignCurrency ? (
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <CurrencyToggle
              storageKey="currency-toggle-account"
              originalCurrency={account?.currency}
            />
          </Box>
        ) : undefined
      }
    />
  );
};
